import React from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import {
  DcButton,
  DcDiv,
  DcFlexBox,
  DcTag,
  DcText,
  colors,
  PixelDate,
  PixelFactoryContext,
  PixelPageContainer,
  PixelTag,
  Section,
  SectionContent,
  PixelTooltip,
} from 'pixel-base'
import TeamComments from 'pixel-base/components/dc-comments/dc-team-comments'
import { AjaxResponse } from 'rxjs/ajax'
import styled from 'styled-components'

import {
  addAComment,
  getComplaintDetails,
  reOpenComplaint,
  updateComplaint,
} from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../decl.d'

const SupportDetail = ({ typeId }) => {
  const navigate = useNavigate()
  const {
    showLoader,
    hideLoader,
    showPageLoader,
    hidePageLoader,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)

  const supportDetailRef = React.useRef(null)
  const addCommentRef = React.useRef(null)
  const [data, setData] = React.useState<any>([])
  const [newComment, setNewComment] = React.useState<any>({
    note: '',
  })

  React.useEffect(() => {
    if (typeId) {
      getDetail(typeId)
    }
  }, [typeId])

  const getDetail = (id) => {
    showLoader(supportDetailRef)
    getComplaintDetails(id).subscribe((res: AjaxResponse<any>) => {
      hideLoader(supportDetailRef)
      setData(res.response.data)
    })
  }

  const addNewComment = (commentObj) => {
    showLoader(addCommentRef)
    addAComment(typeId, commentObj).subscribe((res: AjaxResponse<any>) => {
      hideLoader(addCommentRef)
      const newData = [res.response, ...data.notes]
      setData({ ...data, notes: newData })
      setNewComment({ note: '' })
    })
  }
  const handleUpdateComplaint = () => {
    pixelConfirm({
      title: 'Confirmation',
      message:
        'You will not be able to edit this complaint after marking it as Resolved',
      onConfirm: () => {
        showPageLoader()
        updateComplaint(typeId).subscribe((res: AjaxResponse<any>) => {
          hidePageLoader()
          setData(res.response.data)
        })
      },
    })
  }
  const handleReopenComplaint = () => {
    showPageLoader()
    reOpenComplaint(typeId).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()

      setData(res.response.data)
    })
  }
  const teamComments = (data?.notes || []).map((note, index) => ({
    id: note.id?.toString() || index.toString(),
    author: {
      name: note.created_by || 'Unknown User',
      username: (note.created_by || 'unknown')
        .toLowerCase()
        .replace(/\s+/g, '.'),
      role: note.role || 'Team Member',
    },
    content: note.note || '',
    timestamp: moment(note.created_at).fromNow(),
    likes: 0,
    isLiked: false,
  }))
  return (
    <>
      <DcFlexBox
        height="auto"
        justifyContent="flex-end"
        padding="0px 10px 0px 10px"
      >
        <DcButton margin="5px" disabled size={'sm'}>
          Delete
        </DcButton>
        {data.complaint_status === 'closed' ? (
          <>
            <DcButton
              margin="5px"
              size={'sm'}
              onClick={() => {
                handleReopenComplaint()
              }}
            >
              Reopen
            </DcButton>
          </>
        ) : (
          <>
            <DcButton margin="5px" disabled size={'sm'}>
              Edit
            </DcButton>
            <DcButton
              margin="5px"
              size={'sm'}
              onClick={() => {
                handleUpdateComplaint()
              }}
            >
              Resolve
            </DcButton>
          </>
        )}
      </DcFlexBox>
      <PixelPageContainer
        padding={'10px'}
        maxHeight={'calc(100vh - 85px)'}
        style={{ height: '100%' }}
        className="Supportcharts"
        ref={supportDetailRef}
      >
        <DcFlexBox flexDirection="column">
          <Section style={{ padding: '10px' }}>
            <SectionContent style={{ display: 'flex', padding: '20px' }}>
              <DcFlexBox flexDirection="column" width="33.3%">
                <DcDiv width="35%">
                  <DcText
                    style={{
                      fontSize: '16px',
                      color: '#344050',
                      fontWeight: '600',
                      marginBottom: '1rem',
                      lineHeight: '1.2',
                      textTransform: 'uppercase',
                    }}
                  >
                    Complaint Details
                  </DcText>
                </DcDiv>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Order #
                    </DcText>
                  </DcDiv>
                  <PixelTooltip tooltipText="Go Back to Order">
                    <DcDiv
                      hoverStyle={{
                        color: colors.primaryActive,
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                      color="rgba(0, 0, 0, 0.5)"
                      onClick={() => {
                        navigate(`/orders/?order_id=${data.order_id}`)
                      }}
                      width="50%"
                    >
                      {data.order_id}
                    </DcDiv>
                  </PixelTooltip>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Statu
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    <DcTag
                      textColor="#f2bc16"
                      customBackgroundColor="#fdf7e3"
                      className="warning"
                    >
                      {data.complaint_status}
                    </DcTag>
                  </DcDiv>
                </DcFlexBox>

                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Complaint Type
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    <DcTag textColor="#df3c4e" customBackgroundColor="#fbe8ea">
                      {data.complaint_type}
                    </DcTag>
                  </DcDiv>
                </DcFlexBox>

                {data.complaint_type === 'product' && (
                  <DcFlexBox justifyContent="flex-start" width="100%">
                    <DcDiv width="35%">
                      <DcText
                        style={{
                          color: '#5E6E82',
                          fontWeight: '600',
                          marginBottom: '1rem',
                        }}
                      >
                        Resolution Type
                      </DcText>
                    </DcDiv>
                    <DcDiv width="50%">
                      <DcTag
                        textColor="#2dc58c"
                        customBackgroundColor="#e6f8f1"
                      >
                        {data.resolution_type}
                      </DcTag>
                    </DcDiv>
                  </DcFlexBox>
                )}
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Refund Amount #
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">{data.refund_amount}</DcDiv>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Store
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">{data?.order_info?.store_name}</DcDiv>
                </DcFlexBox>

                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Created By
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">{data.created_by}</DcDiv>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Creation Date
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    {' '}
                    <PixelDate
                      format={'dateWithTime'}
                      value={data.created_at}
                    />
                  </DcDiv>
                </DcFlexBox>
              </DcFlexBox>

              <DcFlexBox flexDirection="column" width="33.3%">
                <DcDiv width="35%">
                  <DcText
                    style={{
                      fontSize: '16px',
                      color: '#344050',
                      fontWeight: '600',
                      marginBottom: '1rem',
                      lineHeight: '1.2',
                      textTransform: 'uppercase',
                    }}
                  >
                    Shipping Details
                  </DcText>
                </DcDiv>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Shipped To
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    {data?.shipping_address?.first_name}
                    {data?.shipping_address?.last_name}
                  </DcDiv>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Phone
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    {data?.shipping_address?.phone || '--'}
                  </DcDiv>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Dispatched On
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    {data?.order_shipping?.dispatch_time.length > 0 ? (
                      <>
                        {moment(data?.order_shipping?.dispatch_time).format(
                          'MMM DD, YYYY, h:mm:ss A',
                        )}
                      </>
                    ) : (
                      '--'
                    )}
                  </DcDiv>
                </DcFlexBox>
                <DcFlexBox justifyContent="flex-start" width="100%">
                  <DcDiv width="35%">
                    <DcText
                      style={{
                        color: '#5E6E82',
                        fontWeight: '600',
                        marginBottom: '1rem',
                      }}
                    >
                      Address
                    </DcText>
                  </DcDiv>
                  <DcDiv width="50%">
                    {data?.shipping_address?.address}
                    {data?.shipping_address?.city}
                  </DcDiv>
                </DcFlexBox>
                {data?.order_shipping?.courier_name.length > 0 && (
                  <DcFlexBox justifyContent="flex-start" width="100%">
                    <DcDiv width="35%">
                      <DcText
                        style={{
                          color: '#5E6E82',
                          fontWeight: '600',
                          marginBottom: '1rem',
                        }}
                      >
                        Shipper
                      </DcText>
                    </DcDiv>
                    <DcDiv width="50%">
                      <PixelTag className="success">
                        {data?.order_shipping?.courier_name || '--'}
                      </PixelTag>
                    </DcDiv>
                  </DcFlexBox>
                )}
                {data?.order_shipping?.tracking_id.length > 0 && (
                  <DcFlexBox justifyContent="flex-start" width="100%">
                    <DcDiv width="35%">
                      <DcText
                        style={{
                          color: '#5E6E82',
                          fontWeight: '600',
                          marginBottom: '1rem',
                        }}
                      >
                        Tracking
                      </DcText>
                    </DcDiv>
                    <DcDiv width="50%">
                      {data?.order_shipping?.tracking_id || '--'}
                    </DcDiv>
                  </DcFlexBox>
                )}
              </DcFlexBox>

              {data.complaint_type === 'product' && (
                <DcFlexBox flexDirection="column" width="33.3%">
                  <DcDiv width="35%">
                    <DcText
                      // margin="0 0 1rem  0"
                      style={{
                        fontSize: '16px',
                        color: '#344050',
                        fontWeight: '600',
                        marginBottom: '1rem',
                        lineHeight: '1.2',
                        textTransform: 'uppercase',
                      }}
                    >
                      Return Details
                    </DcText>
                  </DcDiv>
                  <DcFlexBox justifyContent="flex-start" width="100%">
                    <DcDiv width="35%">
                      <DcText
                        style={{
                          color: '#5E6E82',
                          fontWeight: '600',
                          marginBottom: '1rem',
                        }}
                      >
                        Return Status
                      </DcText>
                    </DcDiv>
                    <DcDiv width="50%">
                      {data.item_return_status === 1 ? (
                        <DcTag
                          textColor="#2dc58c"
                          customBackgroundColor="#e6f8f1"
                        >
                          {/* <PixelIcon color="red" fontSize="16px" icon={faBug} /> */}
                          Received
                        </DcTag>
                      ) : (
                        <DcTag
                          textColor="#df3c4e"
                          customBackgroundColor="#fbe8ea"
                        >
                          {/* <PixelIcon color="red" fontSize="16px" icon={faBug} /> */}
                          Not Received
                        </DcTag>
                      )}
                    </DcDiv>
                  </DcFlexBox>
                </DcFlexBox>
              )}
            </SectionContent>
          </Section>
          <Section
            style={{ padding: '10px' }}
            className="addcomment"
            ref={addCommentRef}
          >
            {/* <Section
            style={{ padding: '10px' }}
            className="addcomment"
            ref={addCommentRef}
          >
            <SectionContent style={{ padding: '10px' }}> */}
            {/* <DcText
                // margin="0 0 1rem  0"
                style={{
                  fontSize: '16px',
                  color: '#344050',
                  fontWeight: '600',
                  marginBottom: '1rem',
                  lineHeight: '1.2',
                  textTransform: 'uppercase',
                }}
              >
                Comments
              </DcText>
              <FormGroup>
                <DcInput
                  required
                  as={'textarea'}
                  type={'text'}
                  name={'comment'}
                  placeholder={'Add a comment'}
                  value={data.description ? data.description : newComment.note}
                  onChange={(e) => {
                    setNewComment({
                      note: e.target.value,
                    })
                  }}
                />
              </FormGroup>
              <FormGroup flexEnd>
                <DcButton
                  margin={'10px 0 0 0'}
                  size={'sm'}
                  onClick={() => {
                    if (newComment.note.length > 0) {
                      addNewComment()
                      setNewComment({ note: '' })
                    }
                  }}
                  variant="primary"
                >
                  Add Reply
                </DcButton>
              </FormGroup> */}
            <Title>Team Comments</Title>
            <TeamComments
              comments={teamComments}
              onAddComment={(content) => {
                if (content.length > 0) {
                  addNewComment({ note: content })
                  setNewComment({ note: '' })
                }
              }}
              showAddComment={true}
              currentUser={{
                name: 'Current User', // Replace with actual user name
                avatar: undefined, // Replace with actual avatar
              }}
            />
            {/* </SectionContent>
          </Section> */}
          </Section>
        </DcFlexBox>
      </PixelPageContainer>
    </>
  )
}

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #3e3e3e;
  margin-bottom: 10px;
`

export default SupportDetail
